export default __webpack_public_path__ + "static/media/editIcon.0f0c7acb.svg";